const MuiInput = {

};

export default MuiInput;



// WEBPACK FOOTER //
// ./src/components/OverrideTheme/config/overrides/MuiInput.js